import { ShareIcon } from '@synoptic/ui-kit/icons/react/share.tsx';
import { PostTagButton } from '@synoptic/ui-kit/post-tag-button/post-tag-button.tsx';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { FC } from 'react';
import {
  socialActionsBlock,
  streamFollowers,
} from '@/components/streams/stream-banner/banner-social-actions.css.ts';
import { StreamFollowers } from '@/components/streams/stream-followers/stream-followers.tsx';
import { StreamSubscribersTag } from '@/components/streams/stream-followers/subscribers-tag.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { copyUrlToClipboard } from '@/utils/copy-url-to-clipboard.ts';

export const BannerSocialActions: FC<{
  streamId: string;
  followersCount: number;
  isPaid?: boolean;
  isPrivate?: boolean;
  isAuthor?: boolean;
  isDraft?: boolean;
  isPackage?: boolean;
}> = ({
  streamId,
  followersCount,
  isPaid,
  isPrivate,
  isAuthor,
  isDraft,
  isPackage,
}) => {
  const toast = useToast();

  return (
    <div className={socialActionsBlock}>
      <PostTagButton
        onClick={() => {
          copyUrlToClipboard(
            isPackage
              ? paths.makeStreamPackage(streamId)
              : paths.makeStream(streamId),
          );
          toast.info({ title: 'Link copied to clipboard' });
        }}
        startIcon={<ShareIcon />}
      >
        Share
      </PostTagButton>

      {isPrivate ? (
        <StreamSubscribersTag
          subscribersCount={followersCount}
          streamId={streamId}
          isPaid={isPaid}
          disabled={!isAuthor || isDraft}
        />
      ) : (
        <StreamFollowers
          followersCount={followersCount}
          iconSize={22}
          className={streamFollowers}
        />
      )}
    </div>
  );
};
